"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "polia": {
    "06c3fa99": [{
      "hkey": "131a29cd",
      "slug": "polia",
      "name": "Polia",
      "primary": true,
      "skipSearch": false
    }],
    "cellia": [{
      "hkey": "131a29cd",
      "slug": "polia",
      "name": "Polia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0a66206e": [{
      "hkey": "495907ef",
      "slug": "menniti",
      "name": "Menniti",
      "primary": true,
      "skipSearch": false
    }],
    "minniti": [{
      "hkey": "495907ef",
      "slug": "menniti",
      "name": "Menniti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "50b99525": [{
      "hkey": "131a29cd",
      "slug": "polia",
      "name": "Polia",
      "primary": true,
      "skipSearch": false
    }],
    "poliolo": [{
      "hkey": "131a29cd",
      "slug": "polia",
      "name": "Polia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7cc638e3": [{
      "hkey": "1e1dc94d",
      "slug": "trecroci",
      "name": "Trecroci",
      "primary": true,
      "skipSearch": false
    }],
    "tre-croci": [{
      "hkey": "1e1dc94d",
      "slug": "trecroci",
      "name": "Trecroci",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;